import { Component } from '@angular/core';
import {MenuItem, MenuItemCommandEvent} from "primeng/api";
import {Router} from "@angular/router";
import {newRequest, continueRequest, viewCatalog, preCreditRating, saleReports, storePaymentReports, searchPaymentRequest, thirdPartyPaymentRequest, closingReport} from "../../menuOptions";
import {LocalStorageService, UtilService} from "library";
import {Permission} from "projects/store/src/app/enums";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {PermissionService} from "projects/store/src/app/services/permission.service";
import {UserService} from "projects/store/src/app/services/api/v1/user.service";
import {LocalStorageKey} from "projects/store/src/app/enums/local-storage-key.enum";
import { MenuEventService } from 'projects/store/src/app/services/menu-event.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent {
  items!: MenuItem[];
  userData: any;
  flowType!: string;

  constructor(private router: Router,
              private authService: AuthService,
              private utilService: UtilService,
              private userService: UserService,
              private localStorageService: LocalStorageService,
              private permissionService: PermissionService,
              private menuEventService: MenuEventService) {
    this.userService.updatedUserObservable.subscribe((resp) => this.load())
  }

  ngOnInit() {
    this.load()
    this.userData = this.localStorageService.get(LocalStorageKey.data);
    this.flowType = this.userData.store?.setting?.type_sales_flow ?? null;
  }

  load() {
    this.items = [ { items: [
      {
        label: 'Inicio', icon: 'pi pi-home', command: (event: MenuItemCommandEvent) => this.router.navigate(['/inicio'])
      },{
        label: 'Ventas', class: 'font-bold', icon: 'pi pi-shopping-bag', visible: this.permissionService.checkPermission(Permission['Ventas']), items: [
          {
            label: newRequest.label, class: newRequest.class, icon: newRequest.icon, visible: this.permissionService.checkPermission(Permission[newRequest.permission]),
            command: (event: MenuItemCommandEvent) => {
              this.menuEventService.newSalesFlowSelection();
            }
          },{
            label: 'Ventas deshabilitada', icon: 'pi', visible: ! this.permissionService.checkPermission(Permission['Ventas.NuevaSolicitud']),
            command: (event: MenuItemCommandEvent) => this.router.navigate(['/']), class: {'p-disabled': true }
          },{
            label: continueRequest.labelMenu, class: continueRequest.class, icon: continueRequest.icon, visible: this.permissionService.checkPermission(Permission[continueRequest.permission]),
            command: (event: MenuItemCommandEvent) => {
              if (continueRequest.action) {
                switch (this.flowType) {
                  case 'actual':
                    continueRequest.action('continuar', this.authService);
                  break;
                  default:
                    this.menuEventService.salesFlowSelection();
                    break;
                }
              }
            }
          },{
            label: viewCatalog.label, class: viewCatalog.class, icon: viewCatalog.icon, visible: this.permissionService.checkPermission(Permission[viewCatalog.permission]),
            command: (event: MenuItemCommandEvent) => {
              if (viewCatalog.action) {
                viewCatalog.action('productos/catalogo', this.authService);
              }
            }
          },{
            label: preCreditRating.label, class: preCreditRating.class, icon: preCreditRating.icon, visible: this.permissionService.checkPermission(Permission[preCreditRating.permission]),
            command: (event: MenuItemCommandEvent) => {
              if (preCreditRating.action){
                preCreditRating.action('pre-calificacion-credito', this.authService);
              }
            }
          },
        ]
      },{
        label: 'Recaudos', class: 'font-bold', icon: 'pi pi-download', visible: this.permissionService.checkPermission(Permission['Recaudos']), items: [
          {
            label: 'Recargas CW', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Recaudos.RecargasCW']),
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('recaudador/cw/recarga')
          },{
            label: 'Luki Cash IN', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Recaudos.LukiCashIn']),
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('recaudador/luki/cash-in')
          },{
            label: 'Luki Cash OUT', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Recaudos.LukiCashOut']),
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('recaudador/luki/cash-out')
          }
        ]
      },{
        label: 'Gestión', class: 'font-bold', icon: 'pi pi-file-edit', visible: this.permissionService.checkPermission(Permission['Gestion']), items: [
          {
            label: 'Gestión de precios', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Gestion.Precios']),
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('productos/editar')
          },{
            label: 'Estado de cuenta', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Gestion.EstadoCuenta']),
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('reportes/estado-cuenta-cliente')
          }
        ]
      },{
        label: 'Cobro de cuota', class: 'font-bold', icon: 'pi pi-wallet', visible: this.permissionService.checkPermission(Permission['SolicitudPago']), items: [
          {
            label: searchPaymentRequest.label, class: searchPaymentRequest.class, icon: searchPaymentRequest.icon, visible: this.permissionService.checkPermission(Permission[searchPaymentRequest.permission]),
            command: (event: MenuItemCommandEvent) => {
              if (searchPaymentRequest.action) {
                searchPaymentRequest.action('pagos/buscar', this.authService);
              }
            }
          },{
            label: thirdPartyPaymentRequest.label, class: thirdPartyPaymentRequest.class, icon: thirdPartyPaymentRequest.icon, visible: this.permissionService.checkPermission(Permission[thirdPartyPaymentRequest.permission]),
            command: (event: MenuItemCommandEvent) => {
              if (thirdPartyPaymentRequest.action) {
                thirdPartyPaymentRequest.action('pagos/nuevo', this.authService);
              }
            }
          }
        ]
      },{
        label: 'Consultas', class: 'font-bold', icon: 'pi pi-question-circle', visible: true, items: [
          {
            label: 'Pin de desbloqueo', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Consultas.PinDesbloqueo']),
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('consultas/pin-desbloqueo')
          },
          {
            label: $localize`:@@layout.menu.cancellationLetter:Carta de cancelación`, class: 'font-bold', icon: 'pi pi-empty', visible: true,
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('consultas/cartas-cancelacion')
          }
        ]
      },{
        label: 'Reportes', class: 'font-bold', icon: 'pi pi-chart-bar', visible: this.permissionService.checkPermission(Permission['Reportes']), items: [
          {
            label: 'Ventas', class: saleReports.class, icon: saleReports.icon, visible: this.permissionService.checkPermission(Permission[saleReports.permission]),
            command: (event: MenuItemCommandEvent) => {
              if (saleReports.action){
                saleReports.action('reportes/ventas', this.authService);
              }
            }
          },{
            label: 'Pagos en tienda', class: storePaymentReports.class, icon: storePaymentReports.icon, visible: this.permissionService.checkPermission(Permission[storePaymentReports.permission]),
            command: (event: MenuItemCommandEvent) => {
              if (storePaymentReports.action){
                storePaymentReports.action('reportes/pagos-en-tienda', this.authService);
              }
            }
          },{
            label: 'Recaudos', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Reportes.Recaudos']),
            command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('reportes/recaudos')
          },
        ]
      },{
        label: 'Gestión comercial', class: 'font-bold', icon: 'pi pi-briefcase', visible: this.permissionService.checkPermission(Permission['Gestion.Comercial']), items: [
          {
            label: 'Dashboard', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Gestion.Comercial.Dashboard']),
            command: (event: MenuItemCommandEvent) => this.router.navigate(['/comisiones/dashboard'])
          },{
            label: 'Mis tiendas', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Gestion.Comercial.MisTiendas']),
            command: (event: MenuItemCommandEvent) => this.router.navigate(['/comisiones/mis-tiendas'])
          },{
            label: 'Pagos', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Gestion.Comercial.Pagos']),
            command: (event: MenuItemCommandEvent) => this.router.navigate(['/comisiones/pagos'])
          },{
            label: 'Reportes', class: 'font-bold', icon: 'pi pi-empty', visible: this.permissionService.checkPermission(Permission['Gestion.Comercial.Reportes']),
            command: (event: MenuItemCommandEvent) => this.router.navigate(['/comisiones/reportes'])
          }
        ]
      },
      // {
      //   separator: true
      // },{
      //   separator: true
      // },{
      //   separator: true
      // },
      // {
      //   label: 'Cambiar clave', icon: 'pi pi-key', command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('recuperar-clave')
      // },{
      //   label: 'Cerrar sesión', icon: 'pi pi-send', command: (event: MenuItemCommandEvent) => this.authService.gotoSalesModule('auth/logout')
      // }
    ]}];
  }

  private isSellerTraceabilityReportVisible(): boolean {
    const data = this.localStorageService.get(LocalStorageKey.data);

    return data?.distributor?.setting?.habilita_doble_vendedor === true;
  }
}
